<template>
  <div class="vertical-layout vertical-menu-modern menu-expanded">
    <div
      class="main-menu menu-fixed menu-accordion expanded menu-light position-relative zindex-0"
    >
      <ul class="main-menu-content">
        <vertical-nav-menu-items
          :items="menuItem"
          class="navigation navigation-main"
        />
      </ul>
    </div>
  </div>
</template>
<script>
import {
} from 'bootstrap-vue'
import VerticalNavMenuItems from '@/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItemsCustom.vue'
import menuList from '@/views/guide/menu'

export default {
  components: {
    VerticalNavMenuItems,
  },
  data() {
    return {
      menuItem: menuList,
    }
  },
  methods: {
    goTo(id) {
      this.$emit('event', id)
    },
  },
}
</script>
<style>

.guide-left-nav .vertical-layout.vertical-menu-modern.menu-expanded .main-menu {
    width: 100% !important;
    display: block;
}
.guide-left-nav .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation .navigation-header .feather-more-horizontal {
    display: none;
}
.guide-left-nav .main-menu.menu-light .navigation > li > a {
    margin: 0 0 0 15px !important;
}
.guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li > a{
  padding-left: 1rem ;
}
.guide-left-nav .nav-item .menu-content{
  position: relative;
}
.guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li > .menu-content.show li > a {
 padding-left: 2rem ;
}
.guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li > .nav-item .menu-content.show li > .menu-content.show li > a {
 padding-left: 2rem ;
}
.guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li > .menu-content.show li.has-sub > a {
 padding-left: 1rem ;
}
.guide-left-nav .main-menu.menu-light .navigation > li ul li ul a {
    padding: 10px 42px 10px 10px;
}
/* .guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li >  a span{
  padding-left:2rem;
} */
/* .guide-left-nav .nav-item .menu-content.show > .nav-item .menu-content.show li > .menu-content.show li > a span{
  padding-left:2rem;
} */
.guide-left-nav .main-menu.menu-light .navigation .navigation-header span {
    font-weight: 700;
    font-size: 1.5rem;
    color: #4B4B4B;
}
.guide-left-nav .main-menu.menu-light .navigation .navigation-header{
    padding: calc(1.5rem + 0.286rem) 0 0.8rem 1.7rem;
    margin:0px;
    margin-top: 0.5rem;
}
.guide-left-nav .main-menu.menu-light .navigation > li.active > a, .guide-left-nav .main-menu.menu-light .navigation > li.active > a{
  background:none !important;
  font-weight: 700;
  color:#6E6B7B;
}
.guide-left-nav .main-menu-content .feather-circle{
  display: none;
}
li.navigation-header{
  border-top: 0.5px solid #B9B9C3;
}
li:first-child.navigation-header{
  border: none;
}
.post-break{
  margin: 1.5rem;
}
.guide-left-nav{
  padding-right:0px;
  border-right:0.5px solid #B9B9C3;
}
.guide-con.container{
  border-radius: 7px;
  max-width: 1600px;
}
.guide-left-nav  .main-menu.menu-light .navigation > li ul .active > a{
  color: #6e6b7b;
}
.guide-left-nav  .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, .guide-left-nav  .main-menu.menu-light .navigation > li.sidebar-group-active > a,
.guide-left-nav  .main-menu.menu-light .navigation > li ul .open > a,  .guide-left-nav  .main-menu.menu-light .navigation > li ul .sidebar-group-active > a , .guide-left-nav  .main-menu.menu-light .navigation>li ul .active{
    background: #fff !important;
}
.guide-left-nav  .main-menu.menu-light .navigation > li > ul li.has-sub > ul > li{
  margin: 0px;
  margin-left: 1rem;
  /* padding-left:5px; */
}
.guide-left-nav  .main-menu.menu-light .navigation > li > ul li.has-sub > a{
  margin-right: 0px;
}
.guide-left-nav .main-menu.menu-light .navigation > li ul li ul li ul li.has-sub > a{
 margin-left:0rem;
}
/* .guide-left-nav .main-menu.menu-light .navigation > li > ul li.has-sub > a{

} */
.guide-left-nav  .main-menu.menu-light .navigation > li ul li > a{
  padding-left: 2rem !important;
}
.guide-left-nav .main-menu.menu-light .navigation > li ul .open > ul .open > ul, .main-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul{
    margin-left: 1rem;
}
.guide-left-nav .main-menu.menu-light .navigation > li ul .open > ul .open > ul .open > ul, .main-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul .open > ul{
    margin-left: 0rem;
}
.guide-left-nav .main-menu.menu-light .navigation > li ul li > a {
    padding: 10px 40px 10px 5px;
}
.guide-left-nav .main-menu.menu-light .navigation li.nav-item a:hover > *, .guide-left-nav .main-menu.menu-light .navigation li.nav-item ul.menu-content li a:hover > *{
  -webkit-transform: none;
   transform: none;
}
.guide-left-nav .main-menu.menu-light .navigation li a > *, .guide-left-nav .main-menu.menu-light .navigation li.has-sub > a,
.guide-left-nav .main-menu.menu-light .navigation li.nav-item ul.menu-content li a:hover > *{
  -webkit-transition: none;
    transition: none;
}
/* .guide-left-nav .main-menu.menu-light .navigation li a >span:hover  {
    animation: sweep 3s linear infinite;
    text-overflow: clip;
    width: 520px;
}
@keyframes sweep {
    0% {
        transform: translate(10%, 0);
    }
    100% {
        transform: translate(-100%, 0);
    }
} */
.close-m-list{
  display:none;
}
.user-guide-m-but, .user-guide-m-but.hide{
  display:none;
}
.guide-left-nav.show .close-m-list{
  display:block;
}
.guide-left-nav.show{
  display: block;
  position: fixed;
  top: 0px;
  height: 100vh;
  width:100vw;
  max-width:100% !important;
  left: 0px;
  z-index: 1000;
  overflow: scroll;
}
@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(110, 197, 185, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(110, 197, 185, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(110, 197, 185, 0);
  }
}
.user-guide-m-but.play{
  animation: pulse-black 2s infinite;
}
@media (max-width: 830px) {
  .guide-left-nav{
      display: none;
    }
  .close-m-list{
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    z-index: 1001;
    border: 0.5px solid #9794a5;
    width: 2.6rem;
    height: 2.6rem;
    text-align: center;
    padding-top: 0.4rem;
    border-radius: 1.3rem;
  }
  .user-guide-m-but{
      width: 4rem;
      height: 4rem;
      position: fixed;
      right: 2rem;
      top: 7.5rem;
      z-index: 1003;
      border-radius: 2.5rem;
      padding: 15px;
      background: #6ec5b9;
       box-shadow: 0 0 0 0 rgba(110, 197, 185, 1);
      display:block;
  }
}
</style>
